<template>
  <fragment>
    <v-banner :sticky="true" class="py-4 pl-0">
      <v-row no-gutters>
        <v-img
          class="rounded-lg"
          max-height="300"
          min-height="300"
          max-width="190"
          min-width="190"
          :lazy-src="product.imagens.imagem1"
          :src="product.imagens.imagem1"
          :alt="product.descricao"
        ></v-img>

        <v-col class="px-3">
          <span class="text-body-1 font-weight-bold">
            {{ product.descricao }}
          </span>
          <v-row no-gutters>
            <v-col class="pr-0">
              <span class="text-h5 grey--darken--text">{{
                formatCurrency(product.preco)
              }}</span>
              <v-row>
                <v-col class="pt-5 pr-0">
                  <span class="text-body-1 grey--text"
                    >Data/Hora:
                    {{
                      formatProductDate(product.dthr_apresentacao) ||
                      " Não informado"
                    }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pr-0">
                  <span class="text-body-1 grey--text"
                    >Estoque: {{ stockQuantity }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pr-0">
                  <span class="text-body-1 grey--text"
                    >Endereço: {{ product.end_local || "Não informado" }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pr-0">
                  <span class="text-body-1 grey--text"
                    >Limite por CPF:
                    {{ product.limite_venda_cpf || "Ilimitado" }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col :max-cols="5" :min-cols="4" class="px-2">
          <v-card elevation="1">
            <v-card-text>
              <v-row v-if="!isOnlyQuantity">
                <v-col cols="12" v-if="hasDate">
                  <v-icon size="24" class="mr-2">{{
                    $config.icons.calendar
                  }}</v-icon>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :nudge-left="!hasHour ? '70' : '0'"
                    :disabled="isProductUnavailable"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseButton
                        text
                        plain
                        class="px-1"
                        variant="small"
                        color="grey--darken--text"
                        min-width="140"
                        :disabled="isProductUnavailable"
                        ref="dateBtn"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ formatProductDate(date) || "Selecione a data" }}
                      </BaseButton>
                    </template>
                    <v-date-picker
                      class="mt-2"
                      locale="pt-BR"
                      v-model="date"
                      @change="save"
                      :color="$config.dados.corinputs"
                      :allowed-dates="allowedDates"
                      id="data-btn"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12" v-if="hasHour">
                  <v-item-group v-model="selectedHour">
                    <v-item
                      v-for="hour in hours"
                      :key="hour"
                      v-slot="{ active, toggle }"
                      class="my-1 mr-1"
                    >
                      <v-chip
                        label
                        active-class="active-class"
                        :input-value="active"
                        @click="toggle"
                      >
                        {{ hour }}
                      </v-chip>
                    </v-item>
                  </v-item-group>
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12">
                  <v-icon size="24" class="mr-2">{{
                    $config.icons.quantity
                  }}</v-icon>
                  <v-list>
                    <v-list-item
                      class="px-0"
                      v-for="(p, index) in quantityPossibilities"
                      :key="index"
                    >
                      <v-list-item-title
                        class="body-2 d-flex grey--text justify-space-between align-center"
                      >
                        <span
                          style="
                            max-width: 50%;
                            white-space: nowrap;
                            margin-right: 5px;
                          "
                          :class="
                            soldOff(index) && inactive(index)
                              ? ''
                              : 'text-decoration-line-through'
                          "
                        >
                          {{ p.descricao }}
                        </span>
                        <div
                          class="quantity-handler d-flex flex-row justify-center mr-n2"
                          v-if="soldOff(index) && inactive(index)"
                        >
                          <BaseButton
                            height="24"
                            width="24"
                            color="black"
                            class="mr-2"
                            x-small
                            @click="onChangeQuantity(index, p.quantity - 1)"
                            :disabled="isProductUnavailable || p.quantity === 0"
                          >
                            <v-icon size="12">$minus</v-icon>
                          </BaseButton>
                          <BaseTextField
                            class="text-inp mr-2"
                            v-model="p.quantity"
                          />
                          <BaseButton
                            height="24"
                            width="24"
                            color="
                              black
                            "
                            class="mr-2"
                            x-small
                            @click="onChangeQuantity(index, p.quantity + 1)"
                            :disabled="isProductUnavailable"
                          >
                            <v-icon size="12">$plus</v-icon>
                          </BaseButton>
                        </div>
                        <div v-else class="d-flex justify-start">
                          <v-chip> Esgotado </v-chip>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12">
                  <v-row>
                    <v-col
                      cols="12"
                      v-if="
                        !isOnlyQuantity && quantityPossibilitiesChosen.length
                      "
                      class="py-2"
                    >
                      <span
                        class="body-2 grey--text d-flex justify-space-between align-center"
                        v-for="(item, index) in quantityPossibilitiesChosen"
                        :key="index"
                      >
                        {{ item }}
                      </span>
                    </v-col>
                    <v-col
                      cols="12"
                      class="d-flex justify-space-between py-2"
                      v-if="formattedTotal"
                    >
                      <span>Total: </span>
                      <span>{{ formattedTotal }}</span>
                    </v-col>
                  </v-row>
                  <v-row class="mt-6" dense v-if="proceeded">
                    <v-col cols="12">
                      <BaseButton
                        variant="black"
                        :disabled="isProductUnavailable"
                        @click="handleClickAddOrRemoveCart"
                        ref="addOrRemoveCartBtn"
                      >
                        {{ cartProduct ? "Remover do " : "Adicionar ao " }}
                        {{ "pacote" }}
                      </BaseButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-if="isOnlyQuantity" dense>
                <span class="mb-2">Selecione a quantidade</span>
                <v-col cols="12">
                  <quantity-handler
                    :quantity="quantityIfOnlyQuantity"
                    :softQuantity="softQuantityIfOnlyQuantity"
                    :isAvailable="false"
                    @on-add="handleAddQuantity"
                    @on-sub="handleSubQuantity"
                    @on-change="handleChangeQuantity($event)"
                    ref="quantityHandler"
                  />
                </v-col>
                <v-col cols="12" class="my-4">
                  <TitleTexts
                    title="Total"
                    :texts="[formattedTotal]"
                    :row="true"
                  />
                </v-col>
                <v-col cols="12" class="mb-4">
                  <v-row justify="center" v-if="proceeded">
                    <BaseButton
                      variant="black"
                      class="rounded-lg"
                      :disabled="isProductUnavailable"
                      @click="handleClickAddOrRemoveCart"
                      ref="addOrRemoveCartBtn"
                    >
                      {{ cartProduct ? "Remover do " : "Adicionar ao " }}
                      {{ "pacote" }}
                    </BaseButton>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-banner>
  </fragment>
</template>

<script>
import { format, compareAsc, parse, isBefore } from "date-fns";
import { formatCurrency, formatProductDate } from "@/utils/productPackage.js";
import { uuid } from "uuidv4";
import _ from "lodash";
import BaseButton from "@/components/forms/BaseButton.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import QuantityHandler from "@/components/vendas/QuantityHandler.vue";
import TitleTexts from "@/components/vendas/TitleTexts.vue";

export default {
  name: "ProductContent",
  components: {
    BaseButton,
    QuantityHandler,
    BaseTextField,
    TitleTexts,
  },
  props: {
    product: {
      type: Object || null,
      required: true,
    },
  },
  computed: {
    hasOptions() {
      return this.product?.variantes?.opcoes.length;
    },
    optionProvider() {
      return this.product?.variantes?.opcoes;
    },
    productVariantsProvider() {
      return this.product?.variantes?.variacoes_produto;
    },
    isOnlyQuantity() {
      return this.product?.variantes?.opcoes?.length === 0;
    },
    hasDate() {
      return this.getDates().length > 0;
    },
    hasHour() {
      return this.getTimes().length > 0;
    },
    hours() {
      let hours = [];
      if (this.hasHour) {
        hours = this.getTimes().map(time => format(time, "HH:mm"));
      }
      return hours;
    },
    cartProduct() {
      // Uncomment if you want to check product in cart
      return false;
    },
    stockQuantity() {
      if (!this.isOnlyQuantity) {
        return this.product?.qtd_estoque_var;
      }

      if (this.isOnlyQuantity && this.product?.qtd_estoque_var) {
        return this.product?.qtd_estoque_var;
      }

      return this.product?.qtd_estoque;
    },
    quantityPossibilitiesChosen() {
      return this.quantityPossibilities
        .filter(({ quantity }) => quantity)
        .map(product => {
          const { preco, quantity, descricao } = product;

          return `${quantity} - ${descricao}: R$ ${quantity * preco}`;
        });
    },
    formattedTotal() {
      return formatCurrency(this.total) || "R$ 0,00";
    },
    proceeded() {
      if (this.isOnlyQuantity) {
        return this.quantityIfOnlyQuantity;
      }

      if (!this.hasDate || !this.hasTime) {
        return this.quantityPossibilities.some(p => p.quantity);
      }

      return (
        this.date &&
        this.selectedHour != null &&
        this.quantityPossibilities.some(p => p.quantity)
      );
    },
    finalProduct() {
      return {
        ...this.product,
        date: this.date,
        hour: this.hours[this.selectedHour],
        uniqueId: this.uniqueId,
        selectedHour: this.selectedHour,
        quantityIfOnlyQuantity: this.quantityIfOnlyQuantity,
        quantityPossibilities: this.quantityPossibilities,
        total: this.total,
      };
    },
    total() {
      let total;

      if (this.isOnlyQuantity) {
        total = this.quantityIfOnlyQuantity * this.preco;
      } else {
        total = this.quantityPossibilities
          .filter(({ quantity }) => quantity)
          .map(({ preco, quantity }) => quantity * Number(preco))
          .reduce((a, b) => a + b, 0);
      }
      return total;
    },
    preco() {
      if (
        this.product.preco_promocional &&
        this.product.preco_promocional != 0
      ) {
        return this.product.preco_promocional;
      }

      return this.product.preco;
    },
  },
  watch: {
    product(product) {
      const { opcoes, variacoes_produto } = product?.variantes;
      if (product.variantes?.opcoes?.length > 0) {
        this.quantityPossibilities = opcoes
          .filter(opcao => opcao.tipo === "TEXTO")
          .map(opcao => {
            const variacaoProduto = variacoes_produto.find(variacao =>
              variacao.nidvariacao.includes(opcao.idvariacao)
            );

            return {
              quantity: 0,
              softQuantity: 0,
              max: Number(variacaoProduto.quantidade),
              ...opcao,
              preco: Number(variacaoProduto.preco),
              taxa_conveniencia: Number(variacaoProduto.taxa_conveniencia),
            };
          });

        if (this.hasDate) {
          this.date = this.minDate;
        } else {
          this.date = null;
        }
        return this.quantityPossibilities;
      }

      this.quantityIfOnlyQuantity = 1;
    },
  },
  methods: {
    soldOff(index) {
      const item = this.quantityPossibilities[index];
      let result;

      this.productVariantsProvider.forEach(element => {
        if (element.nidvariacao[0] === item.idvariacao) {
          if (element.status === "ESGOTADO") {
            result = false;
          } else result = true;
        }
      });
      return result;
    },
    inactive(index) {
      const item = this.quantityPossibilities[index];
      let result;

      this.productVariantsProvider.forEach(element => {
        if (element.nidvariacao[0] === item.idvariacao) {
          if (element.status === "INATIVO") {
            result = false;
          } else result = true;
        }
      });
      return result;
    },
    handleClickAddOrRemoveCart() {
      this.uniqueId = uuid();

      return this.addProductToCart(this.finalProduct);
    },
    allowedDates(val) {
      return (
        this.getDates()
          .map(d => d.descricao)
          .indexOf(val) !== -1
      );
    },
    formatDateCalendar(date) {
      return format(date, "yyyy-MM-dd");
    },
    save() {
      this.menu = false;
      if (this.hasHour && this.selectedHour == null) {
        this.$refs?.hourBtn?.$el?.click();
      } else {
        this.$refs.qttBtn.$el.click();
      }
    },
    handleAddQuantity() {
      this.quantityIfOnlyQuantity += 1;
      this.softQuantityIfOnlyQuantity += 1;
    },
    handleSubQuantity() {
      if (this.quantityIfOnlyQuantity === 1) return;
      this.quantityIfOnlyQuantity -= 1;
      this.softQuantityIfOnlyQuantity -= 1;
    },
    handleChangeQuantity(quantity) {
      this.quantityIfOnlyQuantity = quantity;
      this.softQuantityIfOnlyQuantity = quantity;
    },
    onChangeQuantity(index, newQuantity) {
      this.quantityPossibilities[index].quantity = newQuantity;
    },
    getDates() {
      if (this.hasOptions) {
        const dates = this.optionProvider
          .reduce((acc, option) => {
            if (option.tipo === "DATA") {
              const date = parse(option.descricao, "yyyy-MM-dd", new Date());
              let today = new Date();
              today.setHours(0, 0, 0, 0);
              if (isBefore(date, today)) {
                return acc;
              }
              return [
                ...acc,
                {
                  ...option,
                  descricao: date,
                },
              ];
            }
            return acc;
          }, [])
          .sort((a, b) => compareAsc(a.descricao, b.descricao)) // min first max last
          .map(d => ({
            ...d,
            descricao: this.formatDateCalendar(d.descricao),
          }));
        if (dates.length) {
          return dates;
        }
      }

      return [];
    },
    getTimes() {
      if (this.hasOptions) {
        const hours = this.optionProvider
          .filter(o => o.tipo === "HORA")
          .map(d => parse(d.descricao, "HH:mm", new Date()));
        if (hours.length) {
          return hours.sort(compareAsc); // min first max last
        }
      }

      return [];
    },
    addProductToCart(product) {
      const {
        descricao,
        date,
        hour,
        dthr_apresentacao,
        idproduto,
        imagens,
        quantityPossibilities,
        quantityIfOnlyQuantity,
        total,
        tipo,
      } = product;

      const productInCart = {
        descricao,
        date,
        hour,
        dthr_apresentacao,
        idproduto,
        img: imagens.imagem1,
        quantityPossibilities,
        quantityIfOnlyQuantity,
        total,
        tipo,
      };

      const itens = this.singleProductToVariations(product);
      this.$emit("on-add", { productInCart, itens });
      this.quantityIfOnlyQuantity = 1;
      this.quantityPossibilities = [];
    },
    singleProductToVariations({
      descricao,
      idproduto,
      slug,
      date,
      variantes,
      quantityPossibilities,
      preco,
      preco_promocional,
      quantityIfOnlyQuantity,
      selectedHour,
      dthr_apresentacao,
      imagens,
    }) {
      const { opcoes } = variantes;
      const { imagem1 } = imagens;
      const variationTypes = _.keys(_.keyBy(opcoes, "tipo"));
      let selectedDate;
      let variations = [],
        variationDescriptions = {};

      if (!opcoes.length) {
        return [
          {
            descricao,
            imagem1,
            idproduto,
            slug,
            dthr_apresentacao,
            nidvariacao: [],
            quantidade: quantityIfOnlyQuantity,
            valor:
              preco_promocional && preco_promocional != 0
                ? preco_promocional
                : preco,
          },
        ];
      } else {
        if (variationTypes.includes("DATA")) {
          selectedDate = opcoes.filter(
            option => option.tipo === "DATA" && option.descricao === date
          )[0];

          variations.push(selectedDate?.idvariacao);
          variationDescriptions["DATA"] = selectedDate;
        }

        if (variationTypes.includes("HORA")) {
          let dates = opcoes
            .filter(o => o.tipo === "HORA")
            .map(d => ({
              ...d,
              descricao: parse(d.descricao, "HH:mm", new Date()),
            }))
            .sort((a, b) => compareAsc(a.descricao, b.descricao)); // min first max last

          variations.push(dates[selectedHour].idvariacao);
          variationDescriptions["HORA"] = dates[selectedHour];
        }

        return quantityPossibilities.reduce((acc, variation) => {
          const { idvariacao, quantity, preco } = variation;

          if (quantity > 0) {
            return [
              ...acc,
              {
                descricao,
                idproduto,
                imagem1,
                slug,
                dthr_apresentacao,
                nidvariacao: [...variations, idvariacao],
                idvariacao,
                quantidade: quantity,
                variacoes: { ...variationDescriptions, TEXTO: variation },
                valor: preco,
              },
            ];
          }

          return acc;
        }, []);
      }
    },
  },
  mounted() {
    const { opcoes, variacoes_produto } = this.product?.variantes;
    if (this.product.variantes?.opcoes?.length > 0) {
      this.quantityPossibilities = opcoes
        .filter(opcao => opcao.tipo === "TEXTO")
        .map(opcao => {
          const variacaoProduto = variacoes_produto.find(variacao =>
            variacao.nidvariacao.includes(opcao.idvariacao)
          );

          return {
            quantity: 0,
            softQuantity: 0,
            max: Number(variacaoProduto.quantidade),
            ...opcao,
            preco: Number(variacaoProduto.preco),
            taxa_conveniencia: Number(variacaoProduto.taxa_conveniencia),
          };
        });

      if (this.hasDate) {
        this.date = this.minDate;
      } else {
        this.date = null;
      }
      return this.quantityPossibilities;
    }

    this.quantityIfOnlyQuantity = 1;
  },
  data() {
    return {
      menu: false,
      quantityIfOnlyQuantity: 1,
      softQuantityIfOnlyQuantity: 1,
      isProductUnavailable: false,
      quantityPossibilities: [],
      selectedHour: null,
      date: null,
      uniqueId: null,
      formatProductDate,
      formatCurrency,
    };
  },
};
</script>

<style>
.hour-item {
  width: 50px !important;
  max-width: 50px !important;
}

.v-application--is-ltr .v-banner__wrapper {
  padding-left: 0 !important;
}

.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}

.quantity-handler {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qtd-cart {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 35px !important;
  max-height: 35px !important;
  min-width: 36px !important;
  width: 100%;
}

.text-inp .v-input--dense {
  width: 90px !important;
  height: 40px !important;
}
</style>
